export default __webpack_public_path__ + "static/media/worker3.70c37f0f.jpeg";